// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.black-footer-background{
  width: 100%;
  background-color: #171717;
  font-size: 16px;
  line-height: 1.3rem;
}

.footer-section {
  background-color:#171717;
  color:white;
  width: 80%;
  margin: auto;
  display: flex;
  align-items: top;
  padding-top: 10px;
  justify-content: space-between;
}

.footer-left{
  width: 20%;
}

.quick-links-header{
  font-weight: bold;
  color: #0b97dc;
  padding-bottom: 5px;
}

.link {
  text-decoration: none;
  color: white;
}

.footer-logo{
  width: 120px;
  height: 40px;
}

.footer-links{
  width: 15%;
}

.footer-address{
  width: 30%;
}
.Map-image{
  width: 30%;
}


.social-logo{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: white;
  font-weight: lighter;
  gap:5px;
}

.social-logo-two-line{
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  color: white;
  font-weight: lighter;
  gap:5px;
}

.Address{
  color: #0b97dc;
  font-weight: bold;
  padding-top: 5px;
}

.map-image-context{
  width: 100%;
}



  .footer-bottom {
    background-color: #171717;
    color: #fff;
    display: flex;
    justify-content: space-evenly;
    width: 100%;
    text-align: center;
    align-items: center;
    border-top: rgb(156, 156, 156) solid 1px;
    .footer-social{
      a{
        color: #fff;
      }
    }
  }

  .footer-copyright{
    font-size: 12px;
  }



  @media screen and (max-width: 768px) {
    .black-footer-background{
      font-size: 10px;
      font-weight: 100;
    }
    .footer-section{
      width: 95%;
    }
    .Map-image{
      display: none;
    }
    .quick-links-header{
      font-weight: normal;
    }
    .footer-logo{
      width: 80px;
      height: 25px;
    }
  }


`, "",{"version":3,"sources":["webpack://./src/components/Footer/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;;AAGA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,oBAAoB;EACpB,OAAO;AACT;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;EACZ,oBAAoB;EACpB,OAAO;AACT;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;;;EAIE;IACE,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,6BAA6B;IAC7B,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC;MACE;QACE,WAAW;MACb;IACF;EACF;;EAEA;IACE,eAAe;EACjB;;;;EAIA;IACE;MACE,eAAe;MACf,gBAAgB;IAClB;IACA;MACE,UAAU;IACZ;IACA;MACE,aAAa;IACf;IACA;MACE,mBAAmB;IACrB;IACA;MACE,WAAW;MACX,YAAY;IACd;EACF","sourcesContent":[".black-footer-background{\n  width: 100%;\n  background-color: #171717;\n  font-size: 16px;\n  line-height: 1.3rem;\n}\n\n.footer-section {\n  background-color:#171717;\n  color:white;\n  width: 80%;\n  margin: auto;\n  display: flex;\n  align-items: top;\n  padding-top: 10px;\n  justify-content: space-between;\n}\n\n.footer-left{\n  width: 20%;\n}\n\n.quick-links-header{\n  font-weight: bold;\n  color: #0b97dc;\n  padding-bottom: 5px;\n}\n\n.link {\n  text-decoration: none;\n  color: white;\n}\n\n.footer-logo{\n  width: 120px;\n  height: 40px;\n}\n\n.footer-links{\n  width: 15%;\n}\n\n.footer-address{\n  width: 30%;\n}\n.Map-image{\n  width: 30%;\n}\n\n\n.social-logo{\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  color: white;\n  font-weight: lighter;\n  gap:5px;\n}\n\n.social-logo-two-line{\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  color: white;\n  font-weight: lighter;\n  gap:5px;\n}\n\n.Address{\n  color: #0b97dc;\n  font-weight: bold;\n  padding-top: 5px;\n}\n\n.map-image-context{\n  width: 100%;\n}\n\n\n\n  .footer-bottom {\n    background-color: #171717;\n    color: #fff;\n    display: flex;\n    justify-content: space-evenly;\n    width: 100%;\n    text-align: center;\n    align-items: center;\n    border-top: rgb(156, 156, 156) solid 1px;\n    .footer-social{\n      a{\n        color: #fff;\n      }\n    }\n  }\n\n  .footer-copyright{\n    font-size: 12px;\n  }\n\n\n\n  @media screen and (max-width: 768px) {\n    .black-footer-background{\n      font-size: 10px;\n      font-weight: 100;\n    }\n    .footer-section{\n      width: 95%;\n    }\n    .Map-image{\n      display: none;\n    }\n    .quick-links-header{\n      font-weight: normal;\n    }\n    .footer-logo{\n      width: 80px;\n      height: 25px;\n    }\n  }\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
